import React, { memo } from 'react';
import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackHeight, StackWidth, } from '@voltmoney/schema';
import { FlatList, Pressable, StyleSheet, View, } from 'react-native';
import { Divider } from '../divider/Divider';
import { Typography } from '../typography/Typography';
import { Radio } from '../radio/Radio';
import { Icon } from '../icon/Icon';
import { Space } from '../space/Space';
const Table = ({ width = StackWidth.CONTENT, height = StackHeight.CONTENT, numOfCol, data, titleMap, widgetData, renderItem, sortAction, action, triggerAction, selected = false, allSelectedAction, enablePagination = false, paginationLeftAction, paginationRightAction, titleConfig, }) => {
    const EachRow = ({ item, index }) => {
        const index_i = index;
        return (React.createElement(View, { style: [
                {
                    display: 'flex',
                    flexDirection: 'row',
                    borderLeftWidth: 1,
                    borderRightWidth: 1,
                    borderColor: '#E4E7EC',
                },
                index_i % 2 !== 0
                    ? {
                        backgroundColor: '#F3FAF6',
                    }
                    : {},
                data && index === data.length - 1
                    ? {
                        borderBottomWidth: 1,
                    }
                    : {},
            ] }, data &&
            widgetData &&
            Object.keys(titleConfig).map((fieldName, index) => {
                return (React.createElement(View, { style: [
                        titleConfig[fieldName] &&
                            titleConfig[fieldName].flex
                            ? {
                                flex: titleConfig[fieldName].flex,
                            }
                            : {
                                flex: 2,
                            },
                        titleConfig[fieldName] &&
                            titleConfig[fieldName].cellMinWidth
                            ? {
                                minWidth: titleConfig[fieldName].cellMinWidth,
                            }
                            : {},
                        titleConfig[fieldName] &&
                            titleConfig[fieldName].cellMaxWidth
                            ? {
                                maxWidth: titleConfig[fieldName].cellMaxWidth,
                            }
                            : {},
                        index !==
                            Object.keys(titleConfig).length - 1
                            ? {
                                borderRightWidth: 1,
                                borderColor: '#E4E7EC',
                            }
                            : {},
                    ] },
                    React.createElement(View, { style: {
                            paddingTop: 12,
                            paddingBottom: 12,
                            paddingLeft: 12,
                            paddingRight: 12,
                        } }, renderItem &&
                        widgetData &&
                        widgetData[fieldName] &&
                        widgetData[fieldName][index_i] &&
                        renderItem(widgetData[fieldName][index_i]))));
            })));
    };
    const handleTitlePress = async (item) => {
        triggerAction &&
            sortAction &&
            (await triggerAction({
                ...sortAction,
                payload: {
                    ...sortAction.payload,
                    value: item,
                },
            }));
    };
    const handleAllSelect = async () => {
        console.log('handle select all');
        triggerAction &&
            allSelectedAction &&
            (await triggerAction({
                ...allSelectedAction,
                payload: {
                    ...allSelectedAction.payload,
                    value: true,
                },
            }));
    };
    const handleAllDeSelect = async () => {
        console.log('handle deSelect all');
        triggerAction &&
            allSelectedAction &&
            (await triggerAction({
                ...allSelectedAction,
                payload: {
                    ...allSelectedAction.payload,
                    value: false,
                },
            }));
    };
    const handlePaginationActionLeft = async () => {
        console.log('handle Pagination action');
        triggerAction &&
            paginationLeftAction &&
            (await triggerAction({
                ...paginationLeftAction,
                payload: {
                    ...paginationLeftAction.payload,
                    value: false,
                },
            }));
    };
    const handlePaginationActionRight = async () => {
        console.log('handle Pagination action');
        triggerAction &&
            paginationRightAction &&
            (await triggerAction({
                ...paginationRightAction,
                payload: {
                    ...paginationRightAction.payload,
                    value: false,
                },
            }));
    };
    const tableHeader = (titleConfig) => {
        return (React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                // paddingLeft: 12,
                // paddingRight: 12,
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                backgroundColor: '#F9FAFB',
                borderWidth: 1,
                borderColor: '#E4E7EC',
            } }, titleConfig &&
            Object.keys(titleConfig).map((item, index) => (React.createElement(Pressable, { style: [
                    titleConfig[item] &&
                        titleConfig[item].flex
                        ? {
                            flex: titleConfig[item].flex,
                        }
                        : {
                            flex: 2,
                        },
                    titleConfig[item] &&
                        titleConfig[item].cellMinWidth
                        ? {
                            minWidth: titleConfig[item].cellMinWidth,
                        }
                        : {},
                    titleConfig[item] &&
                        titleConfig[item].cellMaxWidth
                        ? {
                            maxWidth: titleConfig[item].cellMaxWidth,
                        }
                        : {},
                    index !== titleConfig.length - 1 ? {
                        borderRightWidth: 1,
                        borderColor: '#E4E7EC'
                    } : {},
                    {
                        height: '100%'
                    }
                ], onPress: async (event) => {
                    await handleTitlePress(item);
                } }, selected && index === 0 ? (React.createElement(Radio, { isChecked: false, onPressChecked: async () => {
                    await handleAllSelect();
                }, onPressUnChecked: async () => {
                    await handleAllDeSelect();
                }, size: IconSizeTokens.MD })) : (React.createElement(View, { style: {
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 12
                } },
                React.createElement(Typography, { label: titleConfig[item]?.title
                        ? titleConfig[item]?.title
                        : '', fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))))));
    };
    const tableFooter = () => {
        return enablePagination ? (React.createElement(View, { style: {
                flex: 1,
                borderColor: '#E4E7EC',
                borderBottomRightRadius: 8,
                borderBottomLeftRadius: 8,
                borderWidth: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingHorizontal: 16,
                paddingVertical: 12,
                backgroundColor: '#F9FAFB',
            } },
            React.createElement(View, null,
                React.createElement(Typography, { label: 'Page 1 of 10', fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                } },
                React.createElement(Pressable, { style: {
                        position: 'relative',
                        top: 2,
                    }, onPress: handlePaginationActionLeft },
                    React.createElement(Icon, { name: IconTokens.ChevronLeft, size: IconSizeTokens.MD, color: ColorTokens.Grey_Night })),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(Pressable, { onPress: handlePaginationActionRight },
                    React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Night }))))) : (React.createElement(React.Fragment, null));
    };
    if (!data ||
        Object.keys(titleConfig).length === 0) {
        console.log('Data / Title Map Empty found');
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(FlatList, { style: {
            // borderColor: 'blue',
            // borderWidth: 1,
            width: '100%',
        }, data: data, renderItem: EachRow, extraData: [widgetData, data], keyExtractor: (item) => item.id, contentContainerStyle: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
        }, ListHeaderComponent: tableHeader(titleConfig), ItemSeparatorComponent: () => (React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })), ListFooterComponent: tableFooter }));
};
export default memo(Table);
export { Table };
const styles = StyleSheet.create({
    cell: {
        paddingTop: 12,
        paddingBottom: 12,
        height: 42,
        // minWidth: 150,
        width: '100%',
        borderColor: '#E4E7EC',
        borderBottomWidth: 1,
    },
    cellLeftStart: {
        borderLeftWidth: 1,
        borderBottomWidth: 1,
        paddingLeft: 16,
    },
    cellRightEnd: {
        borderRightWidth: 1,
        borderBottomWidth: 1,
    },
    titleCell: {
        borderBottomWidth: 1,
        borderTopWidth: 1,
    },
    titleCellLeft: {
        borderLeftWidth: 1,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        paddingLeft: 16,
        borderTopLeftRadius: 10,
    },
    titleCellRight: {
        borderRightWidth: 1,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderTopRightRadius: 10,
    },
});
